// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  receiptKey: __t.string().primaryKey().name("receipt_key"),
  sectorId: __t.u64().name("sector_id"),
  warId: __t.u64().name("war_id"),
  side: __t.string(),
  at: __t.timestamp(),
});
